import { Link } from "react-router-dom";
import logo from "../assets/images/logo-96.webp";

export const Logo = ({ dark = false, compact = false }) => (
  <Link to="/" data-testid={dark ? "footer-logo-link" : "logo-link"} className="flex items-center gap-3 group">
    <img
      src={logo}
      width="96"
      height="95"
      decoding="async"
      loading={dark ? "lazy" : "eager"}
      data-testid={dark ? "footer-logo-image" : "header-logo-image"}
      alt="WHY NOT HEALTHY FOODS logo"
      className="h-11 w-11 object-cover rounded-full ring-1 ring-parchment bg-white"
    />
    {!compact && (
      <span className="leading-none">
        <span className={`block font-serif font-bold tracking-tight text-[15px] ${dark ? "text-cream" : "text-forest"}`}>
          WHY NOT <span className="text-tang">HEALTHY</span> FOODS
        </span>
        <span className={`block font-mono text-[9px] uppercase tracking-[0.3em] mt-1 ${dark ? "text-cream/50" : "text-sage"}`}>
          Export House · Hyderabad
        </span>
      </span>
    )}
  </Link>
);

export default Logo;
